/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsexplainjoined2Inputs */

const en_statsexplainjoined2 = /** @type {(inputs: Statsexplainjoined2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People per day who joined a plan as going, maybe or on the way.`)
};

const de_statsexplainjoined2 = /** @type {(inputs: Statsexplainjoined2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen pro Tag, die bei einem Plan zugesagt, vielleicht gesagt haben oder unterwegs sind.`)
};

/**
* | output |
* | --- |
* | "People per day who joined a plan as going, maybe or on the way." |
*
* @param {Statsexplainjoined2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsexplainjoined2 = /** @type {((inputs?: Statsexplainjoined2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsexplainjoined2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsexplainjoined2(inputs)
	return de_statsexplainjoined2(inputs)
});
export { statsexplainjoined2 as "statsExplainJoined" }